'use client';

import { useState, useMemo } from 'react';
import Link from 'next/link';
import DelegateCard from '../../DelegateCard';
import { useAtomValue } from 'jotai';
import { sortedDelegateAtom } from '@/app/atoms/delegates';
import { tokenInfoAtom } from '@/app/atoms/token';
import { ChevronDownIcon } from '@heroicons/react/16/solid';

const Delegates = () => {
  const [limit, setLimit] = useState(6);
  const delegates = useAtomValue(sortedDelegateAtom);
  const { symbol } = useAtomValue(tokenInfoAtom);

  // sort by votingPower (descending)
  const sortedDelegates = useMemo(() => {
    return [...(delegates ?? [])].sort((a, b) => {
      const powerA = BigInt(a.votingPower ?? 0);
      const powerB = BigInt(b.votingPower ?? 0);
      return powerB > powerA ? 1 : powerB < powerA ? -1 : 0;
    });
  }, [delegates]);

  if (!sortedDelegates.length) {
    return null;
  }

  return (
    <div className="flex flex-col mt-8 max-sm:text-center rounded-md xs:border border-neutral-700">
      <div className="flex flex-col md:flex-row justify-between p-4 sm:border-b border-neutral-700">
        <div className="font-bold whitespace-nowrap">
          {sortedDelegates.length} {sortedDelegates.length > 1 ? 'Delegates' : 'Delegate'}
        </div>
        <p className="text-xxs font-semibold">1 {symbol} = 1 Vote</p>
      </div>
      <div className="pb-4 xs:px-4">
        <div className="grid grid-cols-1 ipad:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {sortedDelegates.slice(0, limit).map((delegate) => (
            <DelegateCard key={delegate.address} delegate={delegate} />
          ))}
        </div>
      </div>
      <div className={`flex justify-between py-8 border-neutral-700`}>
        {limit < sortedDelegates.length && limit === 6 ? (
          <div className="flex flex-col mx-auto" onClick={() => setLimit(12)}>
            <div className="font-bold mx-auto cursor-pointer">Load More</div>
            <ChevronDownIcon className="w-5 h-5 mx-auto" />
          </div>
        ) : (
          limit === 12 &&
          sortedDelegates.length > 12 && (
            <Link
              href="/karratco/view/delegates"
              className="font-bold mx-auto cursor-pointer"
              onClick={() => setLimit(sortedDelegates.length)}
            >
              View All
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default Delegates;
